// CommunityContext.js
import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { getUserCommunities } from '../services/apiPosts';

export const CommunityContext = createContext();

export const CommunityProvider = ({ children }) => {
  const [communities, setCommunities] = useState([]);
  const [pendingCommunities, setPendingCommunities] = useState([]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    if (userData?._id) {
      let payload = { userid: userData._id };
      fetchAllCommunities(payload);
    }
  }, []);



  const fetchAllCommunities = async (payload) => {
    let listCommunities = await getUserCommunities(payload);
    setCommunities(listCommunities?.communities || []);
    setPendingCommunities(listCommunities?.pendingCommunities || []);
  };


  return (
    <CommunityContext.Provider value={{ communities, pendingCommunities, fetchAllCommunities }}>
      {children}
    </CommunityContext.Provider>
  );
};
